import { observable } from 'mobx';
import { Store } from 'bernie-plugin-mobx';

import { NOOP_LOGGER } from 'bernie-logger';

interface ChildModelProps {
  age?: number;
}
export class ChildModel extends Store {
  constructor(state: ChildModelProps = {}) {
    super({}, NOOP_LOGGER);

    this.setState(state);
  }

  private setState(state: ChildModelProps) {
    this.age = state.age ?? ChildModel.DEFAULTS.age;
  }

  public static DEFAULTS = {
    age: 0,
  };

  @observable
  public age!: number;

  public clone(): ChildModel {
    return new ChildModel({ age: this.age });
  }

  public hydrate(state: ChildModelProps): void {
    this.setState(state);
  }
}
